import { Typography } from '@mui/material';
import { useCustomerId, useURLparams } from '@hooks';
import { BoxContainer, FullWidthContent, MainMenuLayout } from '@layouts';
import { Table } from '@molecules';
import { SelectCustomer } from '@organisms';
import { t } from '@config/i18n';
import { columns, DEFAULT_PAGE, DEFAULT_ROWS_PER_PAGE, TransferReceiptParams } from './constants';
import useGetPartnerTransactions from './data/useGetPartnerTransactions';
import SearchBox from './modules/SearchBox/SearchBox';

/**
 * Transfer Receipt Screen
 */
export const TransferReceiptScreen = () => {
  const { params, setURLparams } = useURLparams<TransferReceiptParams>({
    page: String(DEFAULT_PAGE),
    limit: String(DEFAULT_ROWS_PER_PAGE),
  });
  const { customerId } = useCustomerId();
  const { data, isLoading, handlePageChange, handleRowsPerPageChange } = useGetPartnerTransactions({
    partnerId: customerId,
    params,
    setURLparams,
  });
  return (
    <MainMenuLayout>
      <FullWidthContent>
        {!customerId ? (
          <BoxContainer>
            <Typography variant='h3'>{t('COMMON:COMPANY')}</Typography>
            <SelectCustomer />
          </BoxContainer>
        ) : (
          <>
            <SearchBox />
            <Table
              count={data?.totalCount || 0}
              isLoading={isLoading}
              items={data?.page || []}
              columns={columns}
              onPageChange={handlePageChange as () => void}
              onRowsPerPageChange={handleRowsPerPageChange as () => void}
              page={data?.currentPage || DEFAULT_PAGE}
              rowsPerPage={params?.limit || DEFAULT_ROWS_PER_PAGE}
            />
          </>
        )}
      </FullWidthContent>
    </MainMenuLayout>
  );
};
